import React from 'react';
import { Spinner, Trash, Paperclip } from '@phosphor-icons/react';

export const PendingEmailCard = ({ email: e, cases, assigning, discarding, assignTo, discard }) => (
  <div className="bg-white border border-[#E5E7EB] rounded-lg p-4" data-testid={`inbox-pending-${e._id}`}>
    <div className="flex items-start justify-between gap-4 flex-wrap">
      <div className="flex-1 min-w-0">
        <p className="font-ibm font-semibold text-sm text-[#09090B] truncate">{e.subject || '(no subject)'}</p>
        <p className="text-xs text-[#6B7280] font-ibm mt-0.5 truncate">From: {e.from || '—'}</p>
        <p className="text-xs text-[#6B7280] font-ibm">To: <span className="font-mono">{e.to}</span></p>
        <p className="text-[11px] text-[#9CA3AF] font-ibm mt-0.5">Received {new Date(e.received_at).toLocaleString()}</p>
        {e.text_body && (
          <p className="text-xs text-[#09090B] font-ibm mt-2 line-clamp-3 whitespace-pre-wrap">{e.text_body.slice(0, 320)}{e.text_body.length > 320 ? '…' : ''}</p>
        )}
        {(e.attachments_count || 0) > 0 && (
          <p className="text-xs text-[#6B7280] font-ibm mt-1 flex items-center gap-1"><Paperclip size={12} /> {e.attachments_count} attachment{e.attachments_count === 1 ? '' : 's'}</p>
        )}
      </div>
      <div className="flex flex-col gap-2 shrink-0">
        <select data-testid={`inbox-assign-select-${e._id}`} disabled={assigning === e._id}
          onChange={(ev) => assignTo(e._id, ev.target.value)}
          defaultValue=""
          className="px-3 py-1.5 border border-[#E5E7EB] rounded-md text-sm font-ibm focus:outline-none focus:ring-1 focus:ring-[#002FA7]">
          <option value="" disabled>Assign to case…</option>
          {cases.map(c => (
            <option key={c._id} value={c._id}>{c.title}</option>
          ))}
        </select>
        <button onClick={() => discard(e._id)} disabled={discarding === e._id} data-testid={`inbox-discard-${e._id}`}
          className="flex items-center justify-center gap-1.5 px-3 py-1.5 text-sm border border-[#E5E7EB] text-[#6B7280] hover:text-red-600 font-ibm rounded-md hover:border-red-200 transition-all disabled:opacity-50">
          {discarding === e._id ? <Spinner size={12} className="animate-spin" /> : <Trash size={12} />}
          Discard
        </button>
      </div>
    </div>
  </div>
);
